import { connect } from 'react-redux';
import MetricsJobInfoComponent from './../Components/MetricsJobInfoComponent.jsx';
import {
  build as buildConstants,
  params as paramHelpers,
  pageTypes
} from './../helpers';
import {
  buildsReducer,
  jobsReducer,
  metricsReducer,
  metricPageReducer,
  paramsReducer
} from '../reducers';
import {
  metrics as metricSelectors,
  metricsPage as metricsPageSelectors
} from '../selectors';

export const mapStateToProps = (state, ownProps) => {
  const lastSelected = metricPageReducer.getMetricsPageLastSelectedJob(state);
  const selectedJob = lastSelected ?
    jobsReducer.getJobById(state, lastSelected.jobId) :
    null;

  const fullParams = selectedJob ?
    paramsReducer.getParamsByJobId(state, selectedJob.id) :
    null;

  const selectedJobMetrics = selectedJob ?
    metricsReducer.getMetricsByJobId(state, selectedJob.id) :
    {};
  const childMetrics = metricSelectors
    .getMetricsPageSelectedJobChildMetrics(state, ownProps.pageType);
  const hasNcfDiff = !!(childMetrics['NCF_ARTIFACTS_DIFFRESULT'] ||
  childMetrics['NCF_SOURCES_DIFFRESULT']);
  const hasCcfDiff = !!(childMetrics['CCF_ARTIFACTS_DIFFRESULT'] ||
  childMetrics['CCF_SOURCES_DIFFRESULT']);

  // add previous product versions as additional params
  if (fullParams && ownProps.pageType === pageTypes.CASEMETRICS) {
    const prevVersions =
      buildsReducer.getPreviousBuildVersionFromJobByProduct(state, selectedJob.id);
    fullParams[paramHelpers.PREV_IEF_VERSION] =
      prevVersions[buildConstants.PRODUCTS.IEF_ENGINE];
    fullParams[paramHelpers.PREV_PROCESS_VERSION] =
      prevVersions[buildConstants.PRODUCTS.PROCESS];
  }

  let title = null;
  if (lastSelected) {
    title = lastSelected.value !== undefined ?
      lastSelected.value :
      'Select the highlighted job for info';
  }

  const displayParams = fullParams ?
    paramHelpers.cleanParams(
      fullParams,
      paramHelpers.metricsPageParamsDisplayList
    ) :
    null;

  const metricsActions = metricsPageSelectors.getMetricsOrParamsActions(state)({
    actionNames: metricPageReducer.getMetricsActionNames(state),
    jobId: selectedJob ? selectedJob.id : '',
    hasNcfDiff,
    hasCcfDiff
  });

  const paramsActions = metricsPageSelectors.getMetricsOrParamsActions(state)({
    actionNames: metricPageReducer.getParamsActionNames(state),
    jobId: selectedJob ? selectedJob.id : '',
    prevIefVersion: displayParams ? displayParams[paramHelpers.PREV_IEF_VERSION] : '',
    prevProcessVersion: displayParams ?
      displayParams[paramHelpers.PREV_PROCESS_VERSION] : ''
  });

  const props = {
    title: title,
    displayParams,
    job: selectedJob,
    paramsActions: paramsActions ? paramsActions : [],
    metricsActions: metricsActions ? metricsActions : [],
    metrics: {
      ...childMetrics,
      ...selectedJobMetrics
    },
    hasNcfDiff,
    hasCcfDiff
  };
  return props;
};

export const mapDispatchToProps = (dispatch) => {
  return { onActionButtonClick: (buttonAction) => dispatch(buttonAction) };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MetricsJobInfoComponent);


// WEBPACK FOOTER //
// src/Containers/MetricsJobInfoContainer.jsx